import React from "react";

export const TooltipIcon: React.FC = () => {
  return (
    <svg width={"35"} height={"35"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7120_19654)">
        <path d="M8.93647 16.5919C10.6531 16.8669 12.2781 16.4669 13.5865 15.6336C13.9115 15.4336 14.3281 15.4836 14.6031 15.7586C14.9781 16.1336 14.9198 16.7669 14.4698 17.0503C12.8865 18.0503 10.9448 18.5336 8.88647 18.2669C5.08647 17.7669 2.06147 14.6086 1.70313 10.7919C1.2198 5.55861 5.61147 1.19194 10.8531 1.70861C14.6531 2.08361 17.7781 5.08361 18.2865 8.86694C18.5615 10.9169 18.0781 12.8503 17.0865 14.4253C16.8031 14.8753 16.1698 14.9336 15.7948 14.5586C15.5198 14.2919 15.4615 13.8669 15.6698 13.5419C16.5615 12.1336 16.9448 10.3669 16.5365 8.50861C15.9698 5.96694 13.8865 3.95027 11.3281 3.45861C6.8198 2.60027 2.8948 6.30027 3.3698 10.7503C3.6948 13.6919 6.01147 16.1253 8.93647 16.5919Z" fill="#E3A62C" />
        <path d="M10.0504 11.6711C9.59011 11.6711 9.21702 11.298 9.21702 10.8377V6.67961C9.21702 6.21937 9.59011 5.84627 10.0504 5.84627C10.5106 5.84627 10.8837 6.21937 10.8837 6.67961V10.8377C10.8837 11.298 10.5106 11.6711 10.0504 11.6711Z" fill="#E3A62C" />
        <path d="M9.47168 12.722C9.79711 12.3966 10.3247 12.3966 10.6502 12.722L10.6625 12.7343C10.9879 13.0598 10.9879 13.5874 10.6625 13.9128C10.337 14.2383 9.80941 14.2383 9.48397 13.9128L9.47168 13.9005C9.14624 13.5751 9.14624 13.0475 9.47168 12.722Z" fill="#E3A62C" />
      </g>
      <defs>
        <clipPath id="clip0_7120_19654">
          <rect width={"35"} height={"35"} fill="white" />
        </clipPath>
      </defs>
    </svg>

  );
};
